<template>
  <form class="space-y-8">
    <slot name="header" />
    <slot />
    <slot name="footer" />
  </form>
</template>
